export default "__VITE_ASSET__CyjkwRnH__"